import { useCallback, useRef, useState } from "react";
import { isSunoAudioUrl } from "@shared/suno";
import { createSunoImportGuard } from "@/lib/sunoImportGuard";

type ImportedAudio = { url: string; title?: string | null };
export function useSunoImportRecovery() {
  const guard = useRef(createSunoImportGuard<ImportedAudio>());
  const [failure, setFailure] = useState<{
    url: string;
    message: string;
  } | null>(null);
  const clear = useCallback(() => setFailure(null), []);
  const allowRetry = useCallback((url: string) => guard.current.retry(url), []);
  const run = useCallback(
    async (url: string, fetchAudio: () => Promise<ImportedAudio>) => {
      try {
        const result = await guard.current.run(url, fetchAudio);
        setFailure(null);
        return result;
      } catch (error) {
        if (isSunoAudioUrl(url))
          setFailure({
            url,
            message:
              error instanceof Error
                ? error.message
                : "Could not import this song.",
          });
        throw error;
      }
    },
    [],
  );
  return { failure, clear, allowRetry, run };
}
